var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReward1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2561_1455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2615 20.4597L21.4463 19.3516",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6494 21.4549L17.8692 20.1035",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2822 16.2383L24.6561 16.4545",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3174 2.01758L11.2974 2.99055",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8304 16.0584L19.7201 17.707C20.3338 18.0764 20.6956 17.8151 20.5261 17.1305L19.4316 12.635L22.9991 9.63496C23.5441 9.1755 23.4067 8.75208 22.6923 8.70253L18.0119 8.33766L16.2167 4.0719C15.942 3.41874 15.4886 3.41874 15.2184 4.0719L13.4232 8.33766L8.74284 8.70253C8.02843 8.75658 7.89104 9.1755 8.43601 9.63496L12.0035 12.635L11.7425 13.7205",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04492 22.0984C9.67233 23.0399 11.4309 22.7786 11.4309 22.7786L11.8614 21.0354C12.5849 21.5714 13.423 20.9858 13.423 20.9858L14.1054 17.3867",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4091 13.8151L9.69928 14.1845C9.69928 14.7565 9.55273 16.4637 9.55273 17.0764L13.3675 14.0223C13.6057 13.8241 13.8988 13.7385 14.2148 13.77C14.6086 13.8106 14.9933 14.0313 15.291 14.4007C15.5612 14.7295 15.7123 15.1169 15.7123 15.4818C15.7123 15.8466 15.5657 16.1755 15.291 16.4007L11.4624 19.6079L8.50858 22.6574C8.02315 23.171 7.45986 23.5989 6.31496 23.5989H2.13379",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72382 11.3613L7.12097 11.9334L2.61007 17.3839L2.13379 17.555",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.34375 17.3867H2.13437V24.6615H0.34375",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.57715 6.33789H9.96477",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7188 0.337891V1.70726",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2561_1455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward1);
export default __webpack_public_path__ + "static/media/reward1.c792676d7cef5d0c5929f86b2cfa016b.svg";
export { ForwardRef as ReactComponent };